import {RouterModule, Routes} from '@angular/router';
import {DistributionAccountComponent} from './distribution-account/distribution-account.component';
import {DocumentationComponent} from './documentation/documentation.component';
import {AuthGuardService} from './guards/auth-guard.service';
import {PartnerGuardService} from './guards/partner-guard.service';
import {HomeComponent} from './home/home.component';
import {LogoutComponent} from './logout/logout.component';
import {PartnerComponent} from './partner/partner.component';
import {SegmentComponent} from './segment/segment.component';
import {SigninComponent} from './signin/signin.component';
import {SegmentsModalWrapperComponent} from './segment-multi-share/modal-wrapper/segments-modal-wrapper.component';
import {TaxonomyComponent} from './taxonomy/taxonomy.component';
import {AuditLogsComponent} from './audit-logs/audit-logs.component';
import {AdminGuardService} from './guards/admin-guard.service';
import {SynchronizationComponent} from './synchronization/synchronization.component';
import {MultishareHistoryComponent} from './segment-multi-share/multishare-history/multishare-history.component';

export const routes: Routes = [
  {path: '', component: HomeComponent, canActivate: [AuthGuardService]},
  {path: 'signin', component: SigninComponent},
  {path: 'home', component: HomeComponent, canActivate: [AuthGuardService]},
  {path: 'taxonomy', component: TaxonomyComponent, canActivate: [AuthGuardService]},
  {path: 'multisharehistory', component: MultishareHistoryComponent, canActivate: [AuthGuardService]},
  {path: 'sync', component: SynchronizationComponent, canActivate: [AuthGuardService]},
  {path: 'segments', component: SegmentComponent, canActivate: [AuthGuardService, PartnerGuardService]},
  {path: 'segments/:id', component: SegmentComponent, canActivate: [AuthGuardService, PartnerGuardService]},
  {path: 'segmentsmultishare', redirectTo: '/segments(aside:multishare)', pathMatch: 'full'},
  {
    path: 'multishare',
    component: SegmentsModalWrapperComponent,
    canActivate: [AuthGuardService, PartnerGuardService],
    outlet: 'aside'
  },
  {path: 'partner', component: PartnerComponent, canActivate: [AuthGuardService]},
  {path: 'logout', component: LogoutComponent, canActivate: [AuthGuardService]},
  {path: 'distribution', component: DistributionAccountComponent, canActivate: [AuthGuardService]},
  {path: 'audit-logs', component: AuditLogsComponent, canActivate: [AuthGuardService, AdminGuardService]},
  {path: 'docs', component: DocumentationComponent},
  {
    path: 'ttd',
    loadChildren: () => import('./ttd/ttd.module').then(m => m.TtdModule),
    canActivate: [AuthGuardService]
  }
];

export const ROUTES = RouterModule.forRoot(routes, {relativeLinkResolution: 'legacy'});
